import { createContext } from "react";
import { type LocationType } from "@grnhse/location-control/dist/src/common/types";

export interface LocationControlSettings {
  apiKey: string;
  provider: "mapbox" | "pelias";
  baseUrl: string;
  locationTypes: LocationType[];
}

export const LocationControlSettingsContext = createContext<LocationControlSettings>({
  apiKey: "",
  provider: "pelias",
  baseUrl: "",
  locationTypes: ["city", "state", "country"],
});
